import { useCallback, useMemo, useState } from "react";
import { Modal } from "components/common/Modal";
import { buildExportSelectionInputs } from "../utils/buildExportSelectionInputs";
import { ExportSelectionModalContent } from "./ExportSelectionModalContent";
import type { ExportSelectionModalProps } from "./types";

export const ExportSelectionModal = ({
  isOpen,
  onClose,
  onExport,
  isCablesView,
  isAllElementsMode,
  groupIds,
  byGroupId,
  selectedGroupLabel,
  iconByGroupId,
  isAllRoutesMode,
  routeGroups,
  selectedRouteGroupLabel,
}: ExportSelectionModalProps) => {
  const [isExporting, setIsExporting] = useState(false);

  const { items, initialSelectedLabels } = useMemo(
    () =>
      buildExportSelectionInputs({
        isCablesView,
        isAllElementsMode,
        groupIds,
        byGroupId,
        selectedGroupLabel,
        iconByGroupId,
        isAllRoutesMode,
        routeGroups,
        selectedRouteGroupLabel,
      }),
    [
      isCablesView,
      isAllElementsMode,
      groupIds,
      byGroupId,
      selectedGroupLabel,
      iconByGroupId,
      isAllRoutesMode,
      routeGroups,
      selectedRouteGroupLabel,
    ],
  );

  const handleExport = useCallback(
    async (request: { selectedLabels: string[] }) => {
      setIsExporting(true);
      try {
        await onExport(request);
      } finally {
        setIsExporting(false);
      }
    },
    [onExport],
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      disableBackdropClose={isExporting}
      disableEscapeClose={isExporting}
    >
      <ExportSelectionModalContent
        onClose={onClose}
        onExport={handleExport}
        items={items}
        initialSelectedLabels={initialSelectedLabels}
        isExporting={isExporting}
      />
    </Modal>
  );
};
